export function target() {
  return ['PageSettings'].includes(this.module) && !this.data.selectGtm;
}

export function migrate({ globalGtm }) {
  if (
    !this.data.selectGtm &&
    this.data.gtm &&
    (!globalGtm || globalGtm !== this.data.gtm)
  ) {
    this.data.selectGtm = 'custom';
  } else {
    this.data.selectGtm = 'global';
  }
}
